import { CSSProperties } from 'react';
import {
  AppointmentContactType,
  AppointmentStatus,
  AppointmentConfirmationStatus,
  AtRiskStatus,
  AppointmentCancellationLeadTime,
  AppointmentLeadTime,
  AppointmentAggregatesResponse,
  ScheduleRequestReviewStatus,
} from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';

export type AppointmentAnalyticsV2Filters = {
  locationId?: string[];
  startDate?: string;
  endDate?: string;
  provider?: string[];
  contactType?: AppointmentContactType | undefined;
};

export type AppointmentAnalyticsV2TableFiltersState = AppointmentAnalyticsV2Filters & {
  status?: AppointmentStatus[];
  confirmationStatus?: AppointmentConfirmationStatus;
  atRiskStatus?: AtRiskStatus[];
  cancelLeadTime?: AppointmentCancellationLeadTime;
  leadTime?: AppointmentLeadTime;
};

export type ScheduleRequestsTableFilters = {
  locationId?: string[];
  startDate?: string;
  endDate?: string;
  reviewedStatus?: ScheduleRequestReviewStatus[];
};

export type ViewRendererProps = {
  aggregatesData: AppointmentAggregatesResponse | undefined;
  aggregatesDataLoading: boolean;
  containerStyles?: CSSProperties;
};

export type AppointmentCustomTableView = 'prospect-list' | 'schedule-requests';

export enum ScheduleRequestStackKeys {
  Accepted = 'accepted',
  Pending = 'pending',
  Deleted = 'deleted',
  Done = 'done',
  Messaged = 'messaged',
  Rejected = 'rejected',
  Called = 'called',
  Dismissed = 'dismissed',
}
